export const messages = {
  page: {
    title: {
      id: 'signup.VerifyIdentity.Title',
      defaultMessage: 'First, we need to confirm your identity',
    },
    instruction: {
      id: 'signup.VerifyIdentity.Page.VerifyInfo',
      defaultMessage: 'We keep your personal health information secure by verifying'
         + ' your identity with the information below.',
    },
  },
  form: {
    firstName: {
      id: 'signup.VerifyIdentity.Label.FirstName',
      defaultMessage: 'First Name',
    },
    lastName: {
      id: 'signup.VerifyIdentity.Label.LastName',
      defaultMessage: 'Last Name',
    },
    dateOfBirth: {
      id: 'signup.VerifyIdentity.Label.DateOfBirth',
      defaultMessage: 'Date of birth',
    },
    pin: {
      id: 'signup.VerifyIdentity.Label.Pin',
      defaultMessage: 'PIN',
    },
    ssn: {
      id: 'signup.VerifyIdentity.Label.Ssn',
      defaultMessage: 'SSN',
    },
  },
  required: {
    error: {
      id: 'signup.VerifyIdentity.Required.Error',
      defaultMessage: 'Required',
    },
  },
  helpText: {
    pin: {
      id: 'signup.VerifyIdentity.HelpText.Pin',
      defaultMessage: 'Provided by your care team.',
    },
    mrn: {
      id: 'signup.VerifyIdentity.HelpText.Mrn',
      defaultMessage: 'Your hospital identification number.',
    },
    ssn: {
      id: 'signup.VerifyIdentity.HelpText.Ssn',
      defaultMessage: 'Your social security number.',
    },
  },
  button: {
    next: {
      id: 'signup.VerifyIdentity.Button.Next',
      defaultMessage: 'Next',
    },
    cancel: {
      id: 'signup.VerifyIdentity.Button.Cancel',
      defaultMessage: 'Cancel',
    },
  },
};
